import { mq } from "../../cssInJs";

export default {
  container: mq({
    cursor: "pointer",
    zIndex: "1000",
    position: "absolute",
    padding: "0",
    top: "3px",
    right: ["50px", null, "100px"],
    //border: '1px solid red'
  }),
  countContainer: mq({
    width: ["44px", null, "50px"],
    height: ["44px", null, "50px"],
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "svg": mq({
      width: ["100%"],
      height: ["100%"],
      color: "#000",
    }),
  }),
  count: mq({
    position: "absolute",
    backgroundColor: "#FF0000",
    color: "#FFFFFF",
    borderRadius: "20px",
    padding: "0rem 0.2rem",
    lineHeight: "1",
    top: ["3px", null, "0px"],
    right: "5px",
    //left : ['1.5rem', null, '2rem']
  }),
};
